// import Swiper JS
import Swiper, { Navigation, Pagination, A11y } from 'swiper';
Swiper.use([Navigation, Pagination, A11y]);
import { breakpoint, debounce } from '../../util/helpers';

export default {
  init() {
    this.$modules = document.querySelectorAll('.ms-our-products');
    this.carousels = [];
    this.currentBP = breakpoint();

    // check if module present
    if (!this.$modules.length) {
      return;
    }

    this.currentLang = document.querySelector('html').lang;
    // init
    this.$modules.forEach($module => {
      this.generateSliders($module);
    });

    const onResize = debounce(() => {
      if (breakpoint() !== this.currentBP && this.carousels) {
        this.regenerateSliders();
        this.currentBP = breakpoint();
      }
    }, 10);

    window.addEventListener('resize', onResize);
  },

  regenerateSliders() {
    // destroy sliders
    this.carousels.forEach(carousel => {
      carousel.destroy(false, false);
    });
    this.carousels = [];

    // regenerate sliders
    this.$modules.forEach($module => {
      this.generateSliders($module);
    });
  },

  generateSliders($module) {
    const isOneUp = $module.dataset.variant == 1;
    const isTwoUp = $module.dataset.variant == 2;

    if (isOneUp) {
      return;
    }

    const $slider = $module.querySelector('.swiper-container');

    const sliderItems = $slider.querySelectorAll('a.swiper-slide');

    // currentBP is not accurate 😨
    if (window.outerWidth >= 768) {
      sliderItems.forEach(element => {
        element.querySelector('img').setAttribute('aria-hidden', 'true');
      });
    } else {
      sliderItems.forEach(element => {
        element.querySelector('img').setAttribute('aria-hidden', 'false');
      });
    }

    const activateSliderItem = (activeIndex) => {
      sliderItems.forEach((sliderItem, index) => {

        if (window.outerWidth >= 768) {
          sliderItem.removeAttribute('aria-hidden');
        } else {
          if (index === activeIndex) {
            sliderItem.removeAttribute('aria-hidden');
          } else {
            sliderItem.setAttribute('aria-hidden', 'true');
          }
        }
      });
    }

    if ($slider) {
      const theCarousel = new Swiper($slider, {
        autoHeight: true,
        loop: false,
        watchOverflow: true,
        slidesPerView: 1,
        spaceBetween: 25,
        observer: true,
        observeParents: true,
        a11y: {
          enabled: true,
          firstSlideMessage: 'This is the first slide',
          lastSlideMessage: 'This is the last slide',
          prevSlideMessage: 'Previous slide',
          nextSlideMessage: 'Next slide',
        },
        breakpoints: {
          // when window width is >= 768px; tablet
          768: {
            slidesPerView: 3,
            spaceBetween: isTwoUp ? null : 22,
          },
          // when window width is >= 1280px; desktop
          1280: {
            slidesPerView: 3,
            spaceBetween: isTwoUp ? null : 26,
          },
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        on: {
          init(swiper) {
            activateSliderItem(swiper.activeIndex);
          },
          slideChangeTransitionStart(swiper) {
            activateSliderItem(swiper.activeIndex);
          },
          slideChangeTransitionEnd(swiper) {
            setTimeout(() => {
              if (/iPhone|iPod|iPad/.test(navigator.platform)) {
                swiper.slides[swiper.activeIndex].querySelector('img').focus();
              } else {
                swiper.slides[swiper.activeIndex].focus();
              }
            }, 300);
          },
        },
      });

      this.carousels.push(theCarousel);
    }
  },

  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// /private/var/www/Morton-Windsor/wp-content/themes/morton-salt/resources/assets/scripts/multisite/modules/our-products.js